import {useEffect, useState} from 'react';
import styled from "styled-components";
import colors from "../../../constants/colors";
import { AppNoInfo } from '@/layout/AppComponents';

const ContentLoader = (props) => {
    const {type, numElements, height, right, offset} = props
    const [html, setHtml] = useState(null);
    const style = offset ? {marginLeft: `${offset.l}px`, paddingRight: `${offset.r}px`, marginTop: `${offset.t}px`, marginBottom: `${offset.b}px`} : null


    const typeLine = () => {
        let lineRows = [];

        if(numElements)
            for(let i=0;i<numElements;i++)
                lineRows.push(<span key={i} className="loader single-text"/>);
            else
                lineRows.push(<span key={0} className="loader single-text"/>);

        setHtml(<div className="d-flex flex-column space-between" style={style}>{lineRows}</div>)
    };
    const box = () => {

        setHtml(
            <Loader>
                <div className="d-flex">
                    <span className="loader single-box"/>
                </div>
            </Loader>
        )
    };
    const boxLines = () => {

        let lineRowsTop = [];
        let lineRowsBottom = [];
        if(numElements || numElements < 3)
        {
            for (let i = 0; i < 3; i++)
                lineRowsTop.push(<span key={i} className="loader single-text"/>);
            for (let i = 3; i < numElements; i++)
                lineRowsBottom.push(<span key={i} className="loader single-text"/>);
        }

        else
            for(let i=0;i<3;i++)
                lineRowsTop.push(<span key={i} className="loader single-text"/>);

        setHtml(
            <Loader style={style}>
                <div className="d-flex">
                    <span className="loader single-box"/>
                    <div className="d-flex flex-grow-1 flex-column justify-content-between">
                        {lineRowsTop}
                    </div>
                </div>
                <div className="d-flex flex-column justify-content-between">
                    {lineRowsBottom}
                </div>
            </Loader>
        )
    };
    const buttons = () => {
        let lineRows = [];

        if(numElements)
            for(let i=0;i<numElements;i++)
                lineRows.push(<button key={i} type="button" className="btn btn-outline-light btn-sm disabled">
                    <AppNoInfo />
                </button>);
        else
            lineRows.push(<span key={0} className="loader single-text"/>);

        setHtml(
            <Loader className={`btn-group ${right && 'float-right'} loader`} style={style}>
                {lineRows}
            </Loader>
        )
    };
    const circle = () => {
        let lineRows = [];
        if(numElements)
            for(let i=0;i<numElements;i++)
                lineRows.push(<span key={i} className="loader single-circle" style={height && {height: height, width: height}}/>);
        else
            lineRows.push(<span key={0} className="loader single-circle" style={height && {height: height, width: height}}/>);
        setHtml(
            <Loader>
                <div className="d-flex" style={style}>
                    {lineRows}
                </div>
            </Loader>
        )
    };
    useEffect(() => {
        switch (type) {
            case 'line':
                typeLine();
                break;
            case 'box':
                box();
                break;
            case 'boxLines':
                boxLines();
                break;
            case 'buttons':
                buttons();
                break;
            case 'circle':
                circle();
                break;
        }
    },[]);

    return html;

};

export default ContentLoader;

const Loader = styled.div`
  .loader{
    display: inline-block;
    border-radius: 3px;
    background: rgb(244,246,249);
    margin-bottom: 6px;
    &.single-text{
      height: 6px;
      width: 100%;
      background: rgb(244,246,249);
      margin: 8px 4px;
    }
    &.single-box{
      height: 50px;
      width: 50px;
      margin: 8px 4px;
    }
    &.single-circle{
      height: 50px;
      width: 50px;
      margin: 8px 4px;
      border-radius: 1500px;
    }
    &.btn-group{
      button,
      button:hover{
        background: rgb(244,246,249);
        color:white;
        border: 1px solid white;
      }
    }
  }

  .loader-block{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: ${colors.primary};
  }

  .icon-spin {
    -webkit-animation: icon-spin 2s infinite linear;
    animation: icon-spin 2s infinite linear;
  }
  @-webkit-keyframes icon-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }
  @keyframes icon-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  .react-grid-item{
    overflow-x: hidden;
    overflow-y: hidden;
  }


  .fadeIn{
    -webkit-animation: fadein .2s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein .2s; /* Firefox < 16 */
    -ms-animation: fadein .2s; /* Internet Explorer */
    -o-animation: fadein .2s; /* Opera < 12.1 */
    animation: fadein .2s;
  }


  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
`;
